import React, { Fragment } from 'react';
import { Flex, Box } from 'rebass';
import { Modal, Button } from 'semantic-ui-react';

import { Text } from '../Base';
import { SPACE, FONT_SIZE } from '../Theme';
import NavButton from '../CloseButton';

const RemoveExamModal = ({ roundTitle, examCard, onConfirm, onClose }) => {
  const handleConfirm = () => {
    onClose();
    onConfirm();
  };

  return (
    <Fragment>
      <Modal.Header>
        <Flex justifyContent="space-between">
          ลบวิชาที่จะสอบ
          <NavButton onClick={onClose} />
        </Flex>
      </Modal.Header>
      <Modal.Content>
        <Flex p={SPACE.large} flexDirection="column" alignItems="center">
          <Box pb={SPACE.large}>
            <Text fontSize={FONT_SIZE.large} style={{ textAlign: 'center' }}>
              {`ต้องการลบวิชา`} <b>{`${examCard.subjectName}`}</b> {`ออกจากตารางสอบ`}
              <br />
              {`รอบสอบ `}
              <b>{`${roundTitle}`}</b>
            </Text>
          </Box>
          <Button onClick={handleConfirm} primary circular style={{ width: '160px' }}>
            ยืนยัน
          </Button>
        </Flex>
      </Modal.Content>
    </Fragment>
  );
};
export default RemoveExamModal;
